import { Action, createAction } from 'redux-act';

import Layout from '../../../models/interfaces/layout/Layout';
import MergedTable from '../../../models/interfaces/layout/MergedTable';
import Table from '../../../models/interfaces/layout/Table';
import TableType from '../../../models/interfaces/layout/TableType';
import { Reservation } from '../../../models/interfaces/reservation/Reservation';
import LayoutFormData from '../../../pages/SettingsPage/Layout/LayoutTables/LayoutFormData';
import TimestampPayload from '../TimestampPayload';
import LayoutPayload from './LayoutPayload';

export interface SaveLayoutPayload extends TimestampPayload, LayoutPayload {
  placeUuid: string;
  layoutFormData: LayoutFormData;
}
export const saveLayout = createAction<SaveLayoutPayload>('SAVE_LAYOUT');
export type SaveLayoutActionType = Action<SaveLayoutPayload>;

export interface LayoutSavedPayload extends TimestampPayload, LayoutPayload {
  placeUuid: string;
  layout: Layout;
  mergedTables: MergedTable[];
  tables: Table[];
  tableTypes: TableType[];
  affectedReservations: Reservation[];
}
export const layoutSaved = createAction<LayoutSavedPayload>('LAYOUT_SAVED');

export interface LayoutSaveFailedPayload extends TimestampPayload, LayoutPayload {
  placeUuid: string;
}
export const layoutSaveFailed = createAction<LayoutSaveFailedPayload>('LAYOUT_SAVE_FAILED');
